import Modal from 'flarum/common/components/Modal';

export default class ImageLightboxModal extends Modal {
  className() {
    return 'DiscussionImageLightboxModal Modal--large';
  }

  title() {
    return this.attrs.alt || 'Image';
  }

  content() {
    return (
      <div className="Modal-body DiscussionImageLightboxModal-body">
        <img src={this.attrs.src} alt={this.attrs.alt || ''} />
      </div>
    );
  }
}
